import Backend from "./Backend";
import {BillingPlanDto} from "../model/billing/BillingPlanDto";
import {BillingStatusDto} from "../model/billing/BillingStatusDto";
import {StartCardSetupDto} from "../model/billing/StartCardSetupDto";
import {ActiveSubscriptionStatusDto} from "../model/billing/ActiveSubscriptionStatusDto";

class BillingApi {

    public fetchOptions(companyId: string): Promise<BillingPlanDto[]> {
        return Backend.get(`/api/v1/company/${companyId}/billing`);
    }

    public fetchKey(companyId: string): Promise<{ key: string }> {
        return Backend.get(`/api/v1/company/${companyId}/billing/key`);
    }

    public fetchStatus(companyId: string): Promise<BillingStatusDto> {
        return Backend.get(`/api/v1/company/${companyId}/billing/status`);
    }

    public startCardSetup(companyId: string): Promise<StartCardSetupDto> {
        return Backend.get(`/api/v1/company/${companyId}/billing/new-card`);
    }

    public assignAsDefaultPaymentMethod(companyId: string, intentId: string): Promise<void> {
        return Backend.post(`/api/v1/company/${companyId}/billing/new-card`, {intentId});
    }

    public startSubscription(companyId: string): Promise<void> {
        return Backend.post(`/api/v1/company/${companyId}/billing/subscribe`, {});
    }

    public retrySubscriptionPayment(companyId: string): Promise<{ error: string }> {
        return Backend.post(`/api/v1/company/${companyId}/billing/retry`, {});
    }

    public fetchSubscriptionStatus(companyId: string): Promise<ActiveSubscriptionStatusDto> {
        return Backend.get(`/api/v1/company/${companyId}/billing/active-subscription-status`);
    }
}

export const billingApi = new BillingApi();